import React from 'react'
import Modal from '../../../../../components/UI/Modal/Modal'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Button from '../../../../../components/UI/Button/Button'
import InputGroup from '../../../../../components/UI/Forms/InputGroup/InputGroup'
import { Grid } from '@material-ui/core'

const ActionModal = ({ open, cancelled, submitted, actionForm, actionInputChanged, translate }) => {
  const saveDisabled = Object.values(actionForm).some(item => !item.valid)
  return (
    <Modal
      open={open}
      onHide={cancelled}
      header={translate('action')}
      size={'md'}
      footer={
        <ModalFooter
          submitted={submitted}
          cancelled={cancelled}
          saveDisabled={saveDisabled}
          translate={translate}
        />
      }>
      <ModalContent actionForm={actionForm} actionInputChanged={actionInputChanged} />
    </Modal>
  )
}

export default withTranslate(ActionModal)

const ModalFooter = ({ submitted, cancelled, saveDisabled, translate }) => {
  return (
    <Grid container spacing={1} justify={'flex-end'}>
      <Grid item>
        <Button
          style={{ width: 'inherit' }}
          color={'primary'}
          clicked={submitted}
          disabled={saveDisabled}>
          {translate('save')}
        </Button>
      </Grid>
      <Grid item>
        <Button style={{ width: 'inherit' }} color={'default'} clicked={cancelled}>
          {translate('cancel')}
        </Button>
      </Grid>
    </Grid>
  )
}

const ModalContent = ({ actionForm, actionInputChanged }) => {
  const endDateHidden = actionForm.end_date?.hidden

  const formInputs = Object.entries(actionForm).map(item => {
    const [formKey, formAttrs] = item
    if (formAttrs.hidden) return null
    return (
      <Grid key={formKey} item xs sm md lg={formKey !== 'remark' ? (endDateHidden ? 6 : 3) : 6}>
        <InputGroup
          key={formKey}
          changed={e => actionInputChanged(formKey, e)}
          label={formAttrs.label}
          variant={'outlined'}
          validations={formAttrs.validation}
          touched={formAttrs.touched}
          noMargin
          configs={formAttrs.elementConfig}
          inputValue={formAttrs.value}
          inputType={formAttrs.elementType}
          validationError={formAttrs.error}
          hidden={formAttrs.hidden}
        />
      </Grid>
    )
  })

  return (
    <Grid
      container
      spacing={1}
      alignItems={'flex-start'}
      justify={'space-evenly'}
      direction={'row'}>
      {formInputs}
    </Grid>
  )
}
